var _excluded = ["as", "bold", "children", "color", "italic", "size"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import styled, { css } from 'styled-components';
import getTextStyles from "../../utils/getTextStyles/getTextStyles.js";
import { BODY_TEXT_SIZES } from "./constants.js";
var StyledParagraph = styled.p.withConfig({
  componentId: "CL__sc-1dehrb1-0"
})(["color:", ";", " ", ""], _ref => {
  var {
    color
  } = _ref;
  return color;
}, _ref2 => {
  var {
    bold,
    size
  } = _ref2;
  return size && getTextStyles.bodyText(size, {
    isBold: bold
  });
}, _ref3 => {
  var {
    italic
  } = _ref3;
  return italic && css(["font-style:italic;"]);
});
var BodyText = /*#__PURE__*/React.forwardRef((_ref4, ref) => {
  var {
      as = 'p',
      bold = false,
      children,
      color = 'var(--text-color-dim)',
      italic = false,
      size = BODY_TEXT_SIZES.MEDIUM
    } = _ref4,
    props = _objectWithoutProperties(_ref4, _excluded);
  return /*#__PURE__*/React.createElement(StyledParagraph, _extends({
    as: as,
    bold: bold,
    color: color,
    italic: italic,
    ref: ref,
    size: size
  }, props), children);
});
export default BodyText;